export default __webpack_public_path__ + "static/media/nextjs-logo-1.5a1168d8.svg";